/*
  Global phone number formatter
*/
import React from 'react';

const formatPhoneNumber = (phoneNumberString) => {
   if (!phoneNumberString || phoneNumberString.length < 1) return '';

   const cleaned = (`${ phoneNumberString }`).replace(/\D/g, '');
   let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
   if (match) {
      let intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
   }
   return null;
};

const PhoneNumberFormatter = ({phoneNumber}) => {
   const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
   return (
      <>
         {formattedPhoneNumber}
      </>
   );
};

export default PhoneNumberFormatter;
